module.exports = __webpack_public_path__ + "img/history_Log.6d8d3962.svg";